var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"dot-opacity-loader",staticStyle:{"z-index":"5"}},[_c('span'),_c('span'),_c('span')]):_vm._e(),(_vm.downtimeData && _vm.downtimeData.length)?_c('div',{staticStyle:{"height":"150px"},attrs:{"id":"chartContainer"}}):_c('h4',{staticClass:"text-center p-3"},[_vm._v(_vm._s(_vm.$t('dashboards.noData')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }